import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Paper } from 'shared/ui/Paper';
import { Skeleton } from 'shared/ui/Skeleton';
import { Typography } from 'shared/ui/Typography';

export const HeaderSkeleton = () => (
  <Paper width='100%' mr={6} my={6} p={6} backgroundColor={theme.colors.yellow800}>
    <Box display='flex' alignItems='center' justifyContent='space-between'>
      <Typography as='div' fontSize={theme.fontSizes[36]} fontWeight={theme.fontWeights.extraBold} color={theme.colors.black}>
        <Skeleton width='250px' />
      </Typography>
    </Box>
  </Paper>
);
